module.exports = __webpack_public_path__ + "static/img/feature-icon3@3x.a11e83b6.png";